
import moment from 'moment'

var table = {
    name: 'realestate.clients',
    input_view: {
        forms: [
            {
                col: 'code',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            
            {
                col: 'fullname',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'phone',
                type: 'text',
                value: null, // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'needs_contact',
                type: 'text',
                value: '',
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 3
            },
            {
                col: 'created_at',
                type: 'date',
                value: new Date(),
                defaultValue: moment().format('yyyy-MM-DD'), // default value
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },
            {
                col: 'input_by',
                type: 'select',
                value: 'TUẤN',
                required: false,
                visible: true, // this is generated automatically, we don't need to show to user
                colspan: 2
            },
            {
                col: 'sale',
                type: 'select',
                value: 'TUẤN', // default value
                required: false,
                visible: true,
                colspan: 2
            },
            {
                col: 'source',
                type: 'select',
                value: 'optin form của angiangnhadat', // default value
                required: false,
                visible: true,
                colspan: 3
            },
            {
                col: 'status',
                type: 'select',
                value: 'Data mới', // default value
                required: false,
                visible: true,
                colspan: 2
            },
        ],
    },
    columns: {
        id: {
            'name': 'id',
            'type': 'id',
            'alias': 'ID'
        },
        created_at: {
            'name': 'created_at',
            'type': 'date',
            'alias': 'Ngày tạo',
            formatter: function(value) {
                return moment(value).format('DD/MM/YYYY')
            }
        },
        input_by: {
            'name': 'input_by',
            'type': 'text',
            'alias': 'Người tạo',
            options: [
                'NHI',
                'TUẤN',
                'KIM',
                'CTV-NH',
                'NGUYÊN'
            ]
        },
        code: {
            'name': 'code',
            'type': 'text',
            'alias': 'Mã khách hàng',
        },
        fullname: {
            'name': 'fullname',
            'type': 'text',
            'alias': 'Họ tên',
        },
        phone: {
            'name': 'phone',
            'type': 'text',
            'alias': 'Số điện thoại'
        },
        sale: {
            'name': 'sale',
            'type': 'text',
            'alias': 'Người phụ trách',

            options: [
                'NHI',
                'TUẤN',
                'KIM',
                'CTV-NH',
                'NGUYÊN'
            ]
        },
        needs: {
            'name': 'needs',
            'type': 'text',
            'alias': 'Nhu cầu',
        },        
        source: {
            'name': 'source',
            'type': 'text',
            'alias': 'Nguồn khách hàng',
            options: [
                'Web đăng tin',
                'Facebook',
                'Zalo',
                'CTV gth',
                'KH cũ gth',
                'Network gth',
                'Vợt DA',
                'Tờ rơi - card',
                'Telesale',
                'Quét online',
                'Youtube',
                'Facebook Ads',
                'GG Ads',
                'Website',
                'optin form của kdtgoldencity',
                'optin form của angiangnhadat'
            ]
        },
        status: {
            'name': 'status',
            'type': 'text',
            'alias': 'Mối quan hệ',
            options: [
                'Data mới',
                'Tiếp cận Ko Sđt',
                'Đã tiếp cận',
                'Đã hẹn gặp',
                'Care KH',
                'Chốt sale',
                'Chăm sóc sau BH',
                'Tạm mất KH',
                'Network',
                'Sai đối tượng',
                'VIP club',
                'Đừng quên'
            ]
        },
    },
}

export default {
    table_name: table.name,
    input_view: table.input_view,
    columns: table.columns
}